export default __webpack_public_path__ + "static/media/StarPage1.14035f5f.txt";